export default {
    'name': 'delimiter',
    'width': '24',
    'height': '24',
    'viewBox': '0 0 24 24',
    'data': '<path fill-rule=\'evenodd\' clip-rule=\'evenodd\' d=\'M13 20L13 4L12 4L12 20L13 20Z\' fill=\'#026958\'/>'
}
